import React from 'react';
import { Container } from 'Common';
import pic from 'Static/illustrations/picture.jpg';
import { Wrapper, SkillsWrapper, Details, Thumbnail } from './styles';

const imgStyle = {
  height: 300,
  width: 300,
  objectFit: 'cover',
  borderRadius: '50%',
  objectPosition: 'top',
};

const thumbnailStyle = {
  display: 'flex',
  justifyContent: 'center',
};

export const About = () => (
  <Wrapper id="about">
    <SkillsWrapper as={Container}>
      <Thumbnail style={thumbnailStyle}>
        <img src={pic} style={imgStyle} alt="Ping Cheng" />
      </Thumbnail>
      <Details>
        <h1>About Myself</h1>
        <p style={{ fontSize: '14pt' }}>
          Hi! I am a senior year student at Bilkent University in Ankara,
          Turkey. I mainly specialize in modern front-end development, and am a
          big fan of React and Next.js.
          <br />
          <br />I have lived in several countries throughout my life, including
          Saudi Arabia, Taiwan, Belgium and Turkey. Thanks to that, I can speak
          in Mandarin Chinese, French, English, and Turkish. Feel free to have a
          chat with me in any of these languages!
        </p>
      </Details>
    </SkillsWrapper>
  </Wrapper>
);
